// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"444":"8498a0d7","594":"56a1d75f","899":"71b67d5b"}[chunkId] + ".js";
};